'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../_virtual/_tslib.js');
var React = require('react');
var messageDisplayer = require('@tunz/message-displayer');
var HttpClient = require('@tunz/http');
var WithDataFromUrl_module = require('./WithDataFromUrl.module.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var HttpClient__default = /*#__PURE__*/_interopDefaultLegacy(HttpClient);

/**
 * This is an Higher Order Component (HOC) ==> https://reactjs.org/docs/higher-order-components.html
 * a Higher order component is a component that add some functionality to an existing component.
 *
 * WithDataFromUrl will get first an URL and then another Component as inputs.
 * It will then get the data from the URL and, once fetched, render the provided Component
 * by passing a new prop called 'data' to it.
 *
 * const EnhancedComponent = WithDataFromUrl(url)(Component);
 * <EnhancedComponent />
 */
const WithDataFromUrl = (url) => (WrappedComponent) => { var _a; return _a = class extends React.Component {
        constructor() {
            super(...arguments);
            this.state = {
                isLoading: false,
                data: undefined,
                errorMessage: undefined,
            };
            this.reportError = (error) => {
                let errorMessage = '';
                if (typeof error === 'string') {
                    errorMessage = error;
                }
                if (error instanceof Error) {
                    errorMessage = error.message;
                }
                this.setState((prevState) => (Object.assign(Object.assign({}, prevState), { isLoading: false, errorMessage })));
                messageDisplayer.displayError(errorMessage);
            };
            this.fetchData = () => _tslib.__awaiter(this, void 0, void 0, function* () {
                this.setState((prevState) => (Object.assign(Object.assign({}, prevState), { isLoading: true })));
                try {
                    const response = yield HttpClient__default["default"].get(url);
                    this.setState((prevState) => (Object.assign(Object.assign({}, prevState), { isLoading: false, data: response.data })));
                }
                catch (e) {
                    this.reportError(e);
                }
                finally {
                    this.setState((prevState) => (Object.assign(Object.assign({}, prevState), { isLoading: false })));
                }
            });
        }
        componentDidMount() {
            this.fetchData();
        }
        render() {
            const { isLoading, errorMessage, data } = this.state;
            if (isLoading) {
                return React__default["default"].createElement("div", null, "Loading...");
            }
            if (errorMessage) {
                return React__default["default"].createElement("div", { className: WithDataFromUrl_module["default"].errorMessage }, errorMessage);
            }
            if (data) {
                return React__default["default"].createElement(WrappedComponent, Object.assign({ data: data }, this.props));
            }
            return null;
        }
    },
    _a.displayName = `WithDataFromUrl(${WrappedComponent.displayName ||
        WrappedComponent.name})`,
    _a; };

exports["default"] = WithDataFromUrl;
